import { useState } from "react";
import { HorizontalSplitGroup, VerticalSplitGroup, SplitAlignment } from "./Split";

## Horizontal Split

<div style={{ height: "200px", border: "1px dashed #ccc" }}>
  <HorizontalSplitGroup
    flexibleSide={SplitAlignment.LAST}
    initialFixedSideSize={200}
    minPanelSize={100}
  >
    <div style={{ padding: "1rem", background: "#f5f5f5", height: "100%" }}>
      <h4 style={{ margin: 0 }}>Left Panel</h4>
      <p style={{ fontSize: "14px", color: "#666" }}>Drag the separator to resize</p>
    </div>
    <div style={{ padding: "1rem", height: "100%" }}>
      <h4 style={{ margin: 0 }}>Right Panel</h4>
      <p style={{ fontSize: "14px", color: "#666" }}>This panel is flexible</p>
    </div>
  </HorizontalSplitGroup>
</div>

---

## Vertical Split

<div style={{ height: "300px", border: "1px dashed #ccc" }}>
  <VerticalSplitGroup
    flexibleSide={SplitAlignment.LAST}
    initialFixedSideSize={120}
    minPanelSize={80}
  >
    <div style={{ padding: "1rem", background: "#f5f5f5", height: "100%" }}>
      <h4 style={{ margin: 0 }}>Top Panel</h4>
    </div>
    <div style={{ padding: "1rem", height: "100%" }}>
      <h4 style={{ margin: 0 }}>Bottom Panel</h4>
      <p style={{ fontSize: "14px", color: "#666" }}>Flexible height</p>
    </div>
  </VerticalSplitGroup>
</div>

---

## Non-Draggable Split

<div style={{ height: "150px", border: "1px dashed #ccc" }}>
  <HorizontalSplitGroup
    flexibleSide={SplitAlignment.LAST}
    initialFixedSideSize={150}
    draggable={false}
  >
    <div style={{ padding: "1rem", background: "#e5e5e5", height: "100%" }}>
      <p style={{ margin: 0 }}>Fixed width (not draggable)</p>
    </div>
    <div style={{ padding: "1rem", height: "100%" }}>
      <p style={{ margin: 0 }}>Flexible panel</p>
    </div>
  </HorizontalSplitGroup>
</div>

---

## With Highlight Separator

<div style={{ height: "150px", border: "1px dashed #ccc" }}>
  <HorizontalSplitGroup
    flexibleSide={SplitAlignment.LAST}
    initialFixedSideSize={200}
    minPanelSize={100}
    highlightSeparator
  >
    <div style={{ padding: "1rem", background: "#fafafa", height: "100%" }}>
      <p style={{ margin: 0 }}>Left panel</p>
    </div>
    <div style={{ padding: "1rem", height: "100%" }}>
      <p style={{ margin: 0 }}>Hover over separator to see highlight</p>
    </div>
  </HorizontalSplitGroup>
</div>

---

## Hide Side

export function HideSideDemo() {
  const [hideSide, setHideSide] = useState(SplitAlignment.NONE);
  return (
    <div>
      <div style={{ marginBottom: "0.5rem", display: "flex", gap: "0.5rem" }}>
        <button onClick={() => setHideSide(SplitAlignment.NONE)}>Show Both</button>
        <button onClick={() => setHideSide(SplitAlignment.FIRST)}>Hide Left</button>
        <button onClick={() => setHideSide(SplitAlignment.LAST)}>Hide Right</button>
      </div>
      <div style={{ height: "150px", border: "1px dashed #ccc" }}>
        <HorizontalSplitGroup
          flexibleSide={SplitAlignment.LAST}
          initialFixedSideSize={200}
          hideSide={hideSide}
        >
          <div style={{ padding: "1rem", background: "#e8f4fd", height: "100%" }}>
            <p style={{ margin: 0 }}>Left Panel</p>
          </div>
          <div style={{ padding: "1rem", background: "#fdf8e8", height: "100%" }}>
            <p style={{ margin: 0 }}>Right Panel</p>
          </div>
        </HorizontalSplitGroup>
      </div>
    </div>
  );
}

<HideSideDemo />

---

## IDE Layout Example

<div style={{ height: "350px", border: "1px solid #ccc", borderRadius: "8px", overflow: "hidden" }}>
  <VerticalSplitGroup
    flexibleSide={SplitAlignment.FIRST}
    initialFixedSideSize={100}
    minPanelSize={60}
  >
    <HorizontalSplitGroup
      flexibleSide={SplitAlignment.LAST}
      initialFixedSideSize={180}
      minPanelSize={120}
    >
      <div style={{ background: "#1e1e1e", color: "#ccc", padding: "0.5rem", height: "100%", fontSize: "14px" }}>
        <div style={{ padding: "0.25rem", color: "#fff" }}>Explorer</div>
        <div style={{ padding: "0.25rem", opacity: 0.7 }}>src/</div>
        <div style={{ padding: "0.25rem", marginLeft: "0.5rem", opacity: 0.7 }}>index.ts</div>
        <div style={{ padding: "0.25rem", marginLeft: "0.5rem", opacity: 0.7 }}>App.tsx</div>
        <div style={{ padding: "0.25rem", opacity: 0.7 }}>package.json</div>
      </div>
      <div style={{ background: "#252526", color: "#d4d4d4", padding: "0.5rem", height: "100%", fontFamily: "monospace", fontSize: "13px" }}>
        <div style={{ color: "#569cd6" }}>function</div>
        <div style={{ paddingLeft: "1rem" }}>// Editor content</div>
      </div>
    </HorizontalSplitGroup>
    <div style={{ background: "#1e1e1e", color: "#ccc", padding: "0.5rem", height: "100%", fontSize: "12px", fontFamily: "monospace" }}>
      <div style={{ borderBottom: "1px solid #333", paddingBottom: "0.25rem", marginBottom: "0.25rem" }}>Terminal</div>
      <div style={{ opacity: 0.7 }}>$ npm run dev</div>
      <div style={{ color: "#4ec9b0" }}>Server running on port 3000</div>
    </div>
  </VerticalSplitGroup>
</div>


